var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 21 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.727 1.227a.91.91 0 010 1.818h-.55v5.687l5.616 9.119c.124.248.124.52-.027.745a.742.742 0 01-.646.373H2.113a.743.743 0 01-.645-.373.73.73 0 01.025-.745l5.616-9.12V3.046h-.745a.91.91 0 110-1.818h6.363zm-2.043 1.818H8.598L8.6 8.931a.77.77 0 01-.052.303l-.047.094-2.609 4.223h7.478l-2.585-4.224a1.028 1.028 0 01-.099-.397V3.045z",
    fill: "#777",
    fillRule: "evenodd"
  })));
}
export default SvgTestReport;